import { LoyaltyRewardCardBase } from "types/Loyalty";

import useTranslate from "../../../hooks/useTranslate";
import "./styles.sass";

type LoyaltyGetRewardCardPorps = {
  card: LoyaltyRewardCardBase;
};

export const LoyaltyMoreRewardCard = ({ card }: LoyaltyGetRewardCardPorps) => {
  const { img, title, desc } = card;
  const t = useTranslate();

  return (
    <div className="LoyaltyMoreRewardCard">
      <img src={img} alt="card" className="LoyaltyMoreRewardCard__img" />
      <section className="LoyaltyMoreRewardCard-content">
        <span className="LoyaltyMoreRewardCard-content__title">{t(title)}</span>
        <span className="LoyaltyMoreRewardCard-content__desc">{t(desc)}</span>
      </section>
    </div>
  );
};
